import { differenceInDays, isBefore } from 'date-fns'

import { BACK_TO_SCHOOL_CAMPAIGN_DURATION } from '../constants/backToSchoolCampaignDuration'
import { BACK_TO_SCHOOL_CAMPAIGN_LAUNCH_DATE } from '../constants/backToSchoolCampaignLaunchDate'

export const getBackToSchoolRemainingDays = (): number => {
  const now = new Date()
  if (isBefore(now, BACK_TO_SCHOOL_CAMPAIGN_LAUNCH_DATE)) {
    return 0
  }

  const remainingDays = BACK_TO_SCHOOL_CAMPAIGN_DURATION - differenceInDays(now, BACK_TO_SCHOOL_CAMPAIGN_LAUNCH_DATE)

  return Math.max(0, remainingDays)
}
